import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/jomla/supplier/form PUTs `{name, note}`. `note` has no column on this
 * table, so only `name` gets a pencil; `balance` is ledger-derived and is not
 * in the form. The detail is fetched so an edit cannot blank out `note`.
 */
export default defineInlineEdit({
  api: "jSupplier",
  permission: "j_supplier_edit",
  hydrate: true,
  toPayload: (detail) => ({
    name: detail.name ?? "",
    note: detail.note ?? "",
  }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
